/*eslint-env jquery*/
import React, { Component } from 'react'
import { toastr } from 'react-redux-toastr'
import LoadingCircle from '../Shared/LoadingCircle'
import MySweetAlert from '../Shared/MySweetAlert'
import { answerService } from '../../_services/answer.service'
import { questionService } from '../../_services/question.service'
import ErrorPopUp from '../Shared/ErrorPopUp'
import { FiCircle, FiCheckCircle } from 'react-icons/fi'

import { Formik, getIn, Field, ErrorMessage } from 'formik'
import * as Yup from 'yup'

import { AiOutlineLoading, AiOutlineSave } from 'react-icons/ai'

class AnswerForm extends Component {
  constructor(props, context) {
    super(props, context)

    this.state = {
      loading: false,
      data: [],
      questionId: undefined,
      answer: {
        questionId: this.props.questionId,
        name: '',
        isCorrect: false
      },
      model: {},
      confirmDeleteShow: false
    }

    this.inputFocus = this.utilizeFocus()
  }

  utilizeFocus = () => {
    const ref = React.createRef()
    const setFocus = () => {
      ref.current && ref.current.focus()
    }

    return { setFocus, ref }
  }

  componentDidMount() {
    if (this.props.questionId !== undefined) {
      this.setState({ questionId: this.props.questionId }, () => {
        this.getData()
      })
    }
  }

  componentWillReceiveProps(nextProps) {
    if (
      nextProps.questionId != undefined &&
      nextProps.questionId !== this.state.questionId
    ) {
      this.setState({ questionId: nextProps.questionId }, () => {
        this.getData()
      })
    }
  }

  getData() {
    this.setState({ loading: true })
    questionService
      .getById(this.state.questionId)
      .then(res => {
        // console.log(res.data.answers)
        var data = res.data.answers
        this.setState(
          { data: data, loading: false, isSubmitting: false },
          () => {
            this.inputFocus.value = ''
            this.inputFocus.setFocus()
          }
        )
      })
      .catch(error => {
        // console.log(error)
        this.handleError(error)
      })
  }

  handleSubmit = (values, setSubmitting) => {
    this.setState({ loading: true })

    let dto = values
    dto['questionId'] = values.questionId
    // console.log(dto);
    // console.log(JSON.stringify(dto));

    if (values.id) {
      answerService
        .edit(JSON.stringify(dto))
        .then(res => {
          toastr.success('ویرایش پاسخ انجام شد')
          setSubmitting(false)

          let answer = {}
          answer['name'] = ''
          answer['isCorrect'] = false
          answer['questionId'] = values.questionId

          this.setState({ answer: answer })

          this.getData()

          // this.props.onClose()
        })
        .catch(error => {
          // console.log(error)
          setSubmitting(false)
        })
    } else {
      answerService
        .add(JSON.stringify(dto))
        .then(res => {
          toastr.success('ثبت پاسخ انجام شد')
          setSubmitting(false)

          let answer = {}
          answer['name'] = undefined
          answer['isCorrect'] = false
          answer['questionId'] = values.questionId

          this.setState({ answer: answer })

          this.getData()

          // this.props.onClose()
        })
        .catch(error => {
          // console.log(error)
          setSubmitting(false)
        })
    }
  }

  handleError(error) {
    this.setState({ loading: false })
    // toastr.warning('مشکلی پیش آمد', error);
  }

  handleModalEdit = e => {
    let _model = e
    // console.log(_model);

    this.setState({
      modal: true,
      answer: _model,
      modalHeading: 'ویرایش سوال "' + _model.name + '"'
    })
  }

  handleDelete = e => {
    let _model = e

    this.setState({ confirmDeleteShow: true, model: _model })
  }

  handleConfirmDelete = () => {
    this.setState({ loading: true, confirmDeleteShow: false })

    answerService
      .delete(this.state.model.id)
      .then(res => {
        toastr.success('حذف پاسخ', 'پاسخ با موفقیت حذف شد')
        this.getData()
      })
      .catch(error => {
        this.handleError(error)
      })
  }

  setCorrectAnswer = item => {
    this.setState({ loading: true })

    let dto = item
    dto['isCorrect'] = true

    answerService
      .edit(JSON.stringify(dto))
      .then(res => {
        toastr.success('', 'پاسخ صحیح ذخیره شد')
        this.getData()
      })
      .catch(error => {
        this.handleError(error)
      })
  }

  handleSweetAlertHide = () => {
    this.setState({ confirmDeleteShow: false })
  }

  handleCancelEdit = () => {
    let answer = this.state.data
    answer['name'] = ''
    answer['isCorrect'] = false
    answer['questionId'] = this.props.questionId

    this.setState({ answer: answer })
  }

  render() {
    const { data, answer, loading } = this.state

    const ValidationSchema = Yup.object().shape({
      // questionId: Yup.string().trim().nullable().required(' '),
      name: Yup.string()
        .trim()
        .nullable()
        .required('پاسخ')
    })

    return (
      <Formik
        enableReinitialize
        initialValues={answer}
        onSubmit={(values, { setSubmitting }) => {
          setSubmitting(true)
          this.handleSubmit(values, setSubmitting)
        }}
        validationSchema={ValidationSchema}>
        {props => {
          const {
            values,
            touched,
            errors,
            setFieldValue,
            setFieldTouched,
            isSubmitting,
            handleChange,
            handleBlur,
            handleSubmit,
            validateForm
          } = props
          return (
            <div style={{ position: 'relative' }}>
              <form onSubmit={handleSubmit}>
                <fieldset className="fieldset">
                  <legend>{values.id ? 'ویرایش پاسخ' : 'ثبت پاسخ جدید'}</legend>

                  <div className="row">
                    <div className="form-inline">
                      <div className="col-md-12">
                        <label className="pull-right">پاسخ</label>
                        <input
                          type="text"
                          ref={this.inputFocus.ref}
                          autoFocus
                          name="name"
                          onChange={e => setFieldValue('name', e.target.value)}
                          className={
                            getIn(errors, 'name') && getIn(touched, 'name')
                              ? 'text-input has-error rtl'
                              : 'text-input required rtl'
                          }
                        />
                        <ErrorMessage component={ErrorPopUp} name="name" />
                      </div>

                      <div className="col-md-12">
                        <button
                          type="submit"
                          className="btn btn-success"
                          disabled={isSubmitting}
                          onClick={() =>
                            validateForm().then(errors => {
                              // console.log(errors)
                              // this.validateForm(errors);
                            })
                          }>
                          {isSubmitting ? (
                            <AiOutlineLoading
                              className="mdi-spin"
                              size="18px"
                            />
                          ) : (
                            <AiOutlineSave size="18px" />
                          )}
                          ذخیره
                        </button>
                        {values.id && (
                          <a
                            className="btn btn-default"
                            onClick={() => this.handleCancelEdit()}>
                            لغو ویرایش
                          </a>
                        )}
                      </div>
                    </div>
                  </div>
                </fieldset>
              </form>

              <fieldset
                className="fieldset"
                style={{
                  paddingRight: 0,
                  paddingLeft: 0,
                  paddingBottom: 0,
                  overflow: 'hidden',
                  position: 'relative'
                }}>
                <legend style={{ marginRight: 15 }}>لیست پاسخ ها</legend>

                <table className="table" style={{ marginBottom: 0 }}>
                  <thead>
                    <tr>
                      <th style={{ width: 60 }}>#</th>
                      <th className="text-right">متن پاسخ</th>
                      <th style={{ width: 100 }}>پاسخ صحیح</th>
                      <th style={{ width: 180 }}>عملیات</th>
                    </tr>
                  </thead>
                  <tbody>
                    {data &&
                      data.map((item, index) => (
                        <TableRow
                          key={'tr-' + item.id}
                          data={item}
                          index={index}
                          onReload={() => this.getData()}
                          handleModalEdit={e => this.handleModalEdit(e)}
                          handleDelete={e => this.handleDelete(e)}
                          setCorrectAnswer={e => this.setCorrectAnswer(e)}
                        />
                      ))}
                  </tbody>
                </table>
                {loading && (
                  <LoadingCircle style={{ marginTop: 10, borderRadius: 15 }} />
                )}
              </fieldset>

              <MySweetAlert
                show={this.state.confirmDeleteShow}
                onCancel={this.handleSweetAlertHide}
                onConfirm={this.handleConfirmDelete}
                title={
                  'آیا از حذف پاسخ [' + this.state.model.name + '] مطمئن هستید؟'
                }
              />
            </div>
          )
        }}
      </Formik>
    )
  }
}

export default AnswerForm

const TableRow = ({
  data,
  index,
  setCorrectAnswer,
  handleModalEdit,
  handleDelete
}) => {
  return (
    <tr className={data.isCorrect ? 'active' : ''}>
      <td>{index + 1}</td>
      <td className="text-right">{data.name}</td>
      <td>
        <a
          onClick={() => setCorrectAnswer(data)}
          className="btn btn-sm btn-simple bmd-ripple bmd-flat-btn">
          {data.isCorrect ? (
            <FiCheckCircle size="20px" color="#4caf50" style={{ margin: 0 }} />
          ) : (
            <FiCircle size="20px" color="#597df7" style={{ margin: 0 }} />
          )}
        </a>
      </td>
      <td>
        <a
          onClick={() => handleModalEdit(data)}
          className="btn btn-sm btn-simple btn-success bmd-ripple bmd-flat-btn">
          <i className="mdi mdi-pencil" />
        </a>

        <a
          onClick={() => handleDelete(data)}
          className="btn btn-sm btn-simple btn-danger bmd-ripple bmd-flat-btn delete-btn">
          <i className="mdi mdi-delete" />
        </a>
      </td>
    </tr>
  )
}
